import React, { useState, useEffect } from 'react'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import { I18n } from 'react-redux-i18n'

import { updateActionsErrors } from 'redux/smartchat/details/actions'
import { setAlternativesActionsErrors } from 'redux/smartchat/alternatives/actions'
import SelectorViewUI from './SelectorViewUI'
import { getDataOptions } from 'components/SmartChatView/utils'
import { lang } from 'utils/helpers'

const SelectorView = ({ renderType, label, placeholder, optionsData, actionType, dataWay, currentValue, onChange, link, tooltip, error }) => {
  const { modalActionRef } = useSelector(store => ({
    modalActionRef: dataWay?.type === 'alternatives'
      ? store.smartchatAlternatives.alternativesModalActionRef.find(modalActionRef => modalActionRef.alternativesId === dataWay.alternativesId) || {}
      : store.smartchatDetails.modalActionRef
  }), shallowEqual)
  const dispatch = useDispatch()
  const [options, setOptions] = useState(null)
  const [value, setValue] = useState(null)
  const [dataToExport, setDataToExport] = useState(currentValue || {})
  const [loading, setLoading] = useState(false)
  const [previewIntegrity, setPreviewIntegrity] = useState(null)

  // Get options
  useEffect(() => {
    let isSubscribed = true

    if (isSubscribed) {
      if (optionsData?.optionsName && !optionsData?.options) getOptions()
      if (optionsData?.options && !optionsData?.optionsName) setOptions(optionsData.options)
    }

    return () => isSubscribed = false
  }, [])

  // Current data
  useEffect(() => {
    let isSubscribed = true

    if (isSubscribed) {
      if (!currentValue || !Object.keys(currentValue).length) return

      if (renderType === 'action') {
        if (modalActionRef.mode !== 'update') return
        onChange(currentValue)
      }

      let updatedPreviewIntegrity = previewIntegrity

      // Selector
      if (options?.length) {
        const option = options.find(option => option.value === currentValue[optionsData.fieldName])

        if (option) {
          if (updatedPreviewIntegrity) updatedPreviewIntegrity = null
          setValue(option)
        } else {
          // Error report
          if (currentValue[optionsData.fieldName]) {
            if (renderType === 'action') {
              dataWay?.type === 'alternatives'
                ? dispatch(setAlternativesActionsErrors({ alternativesId: dataWay.alternativesId, actionsErrors: { [actionType]: I18n.t('smartchat_tooltip_warning_notFound') } }))
                : dispatch(updateActionsErrors({ [actionType]: I18n.t('smartchat_tooltip_warning_notFound') }))
            } else {
              updatedPreviewIntegrity = I18n.t('smartchat_tooltip_warning_notFound')
            }
          }
        }
      }

      // Error report
      if (renderType === 'preview') setPreviewIntegrity(updatedPreviewIntegrity)
    }

    return () => isSubscribed = false
  }, [currentValue, options])

  const getOptions = async () => {
    setLoading(true)
    try {
      const result = await getDataOptions({ requestedData: [optionsData.optionsName], params: optionsData.optionsParams })
      const options = result[optionsData.optionsName]
      if (actionType === 'deleteFromManagementList') options.unshift({ value: 'all', label: lang('dashboard_select-all-folders') })
      setOptions(options)
    } finally {
      setLoading(false)
    }
  }

  const onChangeInner = (selectorData) => {
    const updatedDataToExport = { ...dataToExport }

    // Data to export
    if (selectorData) {
      updatedDataToExport[optionsData.fieldName] = selectorData.value
    } else {
      updatedDataToExport[optionsData.fieldName] = null
    }

    // Update local data
    setValue(selectorData)
    setDataToExport(updatedDataToExport)

    // Export the data
    onChange(updatedDataToExport)
  }

  return (
    <SelectorViewUI
      renderType={renderType}
      label={label}
      placeholder={placeholder}
      options={options}
      value={value}
      onChangeInner={onChangeInner}
      link={link}
      tooltip={tooltip}
      loading={loading}
      error={error}
      previewIntegrity={previewIntegrity}
    />
  )
}

export default SelectorView
